module.exports = __webpack_public_path__ + "static/media/bias_rounded_corners.0345cb67.png";